<tidy-wrapper>

  @if (step() === 'landing') {
    <div class="landing-step">
      <div class="brand">
        <img class="logo" src="assets/img/tidy-logo.svg" alt="TIDY" />
        <tidy-text [title]="'Easily keep properties clean & maintained'" />
      </div>

      <div class="social-proof">
        <span class="material-icons star-icon">verified</span>
        <tidy-text [body]="'Trusted by 100,000+ customers & top property managers'" />
      </div>

      <div class="actions">
        <button type="button" class="social-button" [disabled]="isLoading()" (click)="signUpWithGoogle()">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <tidy-text [body]="'Sign up with Google'" />
        </button>

        <button type="button" class="social-button" [disabled]="isLoading()" (click)="signUpWithApple()">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <tidy-text [body]="'Sign up with Apple'" />
        </button>

        <div class="divider">
          <span>or</span>
        </div>

        <tidy-button
          [text]="'Create Account'"
          [action]="goToCreateAccount"
          class="primary full-width" />

        @if (errorMessage()) {
          <tidy-error-message [text]="errorMessage()" />
        }

        <div class="combined-footer">
          <span class="terms-section">
            <a (click)="openUrl('https://www.tidy.com/terms')">Terms</a>
            <span class="separator">•</span>
            <a (click)="openUrl('https://www.tidy.com/legal/privacy-policy')">Privacy</a>
          </span>
          <span class="separator">|</span>
          <span class="sign-in-section">
            <span class="muted-text">Have an account?</span>
            <a class="link" (click)="goToSignIn()">Sign In</a>
          </span>
        </div>
      </div>
    </div>
  }

  @if (step() === 'account-type') {
    <div class="step">
      <div class="step-header-row">
        <tidy-icon class="back-button" name="arrow-back-black" [size]="20" (action)="goBack()" />
        <tidy-text [title]="'How will you use TIDY?'" />
      </div>

      <div class="guest-types">
        @for (type of accountTypes; track type.value) {
          <button
            type="button"
            class="guest-type-card"
            [disabled]="loadingType() !== null"
            (click)="selectAccountType(type.value)">
            <div class="type-icon-wrapper">
              <span class="material-icons type-icon">{{ type.icon }}</span>
            </div>
            <div class="type-content">
              <tidy-text [header]="type.label" />
            </div>
            @if (loadingType() === type.value) {
              <ion-spinner name="lines" class="card-spinner" />
            } @else {
              <img class="arrow-icon" src="assets/img/chevron-right.svg" alt="" />
            }
          </button>
        }
      </div>

      @if (errorMessage()) {
        <tidy-error-message [text]="errorMessage()" />
      }
    </div>
  }

  @if (step() === 'signin') {
    <div class="step">
      <div class="step-header-row">
        <tidy-icon class="back-button" name="arrow-back-black" [size]="20" (action)="goBack()" />
        <tidy-text [title]="'Sign In'" />
      </div>

      <div class="actions">
        <button type="button" class="social-button" [disabled]="isLoading()" (click)="signUpWithGoogle()">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <tidy-text [body]="'Sign in with Google'" />
        </button>

        <button type="button" class="social-button" [disabled]="isLoading()" (click)="signUpWithApple()">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <tidy-text [body]="'Sign in with Apple'" />
        </button>

        <div class="divider">
          <span>or</span>
        </div>
      </div>

      <form [formGroup]="signInForm" class="auth-form">
        <tidy-input
          formControlName="email"
          [form]="signInForm.controls.email"
          [label]="'Email'"
          type="email"
          [errorMessage]="'Please enter a valid email.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/mail.svg'" />
        <tidy-input
          formControlName="password"
          [form]="signInForm.controls.password"
          [label]="'Password'"
          type="password"
          [errorMessage]="'Password is required.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/lock-closed.svg'" />
        @if (errorMessage()) {
          <tidy-error-message [text]="errorMessage()" />
        }
        <tidy-button
          [text]="'Sign In'"
          [action]="onSignIn"
          class="primary full-width" />
      </form>

      <div class="forgot-links">
        <tidy-text [actionBody]="'Forgot password?'" (action)="forgotPassword()" class="link" />
        <tidy-text [actionBody]="'Forgot username?'" (action)="forgotUsername()" class="link" />
      </div>
    </div>
  }

  @if (step() === 'reset-password') {
    <div class="step">
      <div class="step-header-row">
        <tidy-icon class="back-button" name="arrow-back-black" [size]="20" (action)="goBack()" />
        <tidy-text [title]="'Reset Password'" />
      </div>

      <tidy-text
        class="step-subtext"
        [body]="'Enter your email address and we will send you instructions to reset your password.'" />

      <form [formGroup]="resetPasswordForm" class="auth-form">
        <tidy-input
          formControlName="email"
          [form]="resetPasswordForm.controls.email"
          [label]="'Email'"
          type="email"
          [errorMessage]="'Please enter a valid email.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/mail.svg'" />
        @if (errorMessage()) {
          <tidy-error-message [text]="errorMessage()" />
        }
        @if (successMessage()) {
          <div class="success-message">{{ successMessage() }}</div>
        }
        <tidy-button
          [text]="'Send Reset Instructions'"
          [action]="onResetPassword"
          [disabled]="isLoading()"
          class="primary full-width" />
      </form>
    </div>
  }

  @if (step() === 'forgot-username') {
    <div class="step">
      <div class="step-header-row">
        <tidy-icon class="back-button" name="arrow-back-black" [size]="20" (action)="goBack()" />
        <tidy-text [title]="'Forgot Username'" />
      </div>

      <tidy-text
        class="step-subtext"
        [body]="'Enter your account information to recover your username.'" />

      <form [formGroup]="forgotUsernameForm" class="auth-form">
        <tidy-input
          formControlName="phone"
          [form]="forgotUsernameForm.controls.phone"
          [label]="'Phone Number'"
          type="tel"
          [errorMessage]="'Please enter your phone number.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/phone-portrait.svg'" />
        <tidy-input
          formControlName="address1"
          [form]="forgotUsernameForm.controls.address1"
          [label]="'Street Address'"
          [errorMessage]="'Please enter your street address.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/home.svg'" />
        <tidy-input
          formControlName="zipcode"
          [form]="forgotUsernameForm.controls.zipcode"
          [label]="'Zip Code'"
          [errorMessage]="'Please enter your zip code.'"
          [submitted]="submitted()"
          [icon]="'assets/svg/location.svg'" />
        @if (errorMessage()) {
          <tidy-error-message [text]="errorMessage()" />
        }
        @if (successMessage()) {
          <div class="success-message">{{ successMessage() }}</div>
        }
        <tidy-button
          [text]="'Recover Username'"
          [action]="onForgotUsername"
          [disabled]="isLoading()"
          class="primary full-width" />
      </form>
    </div>
  }

</tidy-wrapper>
